import { cleanName } from '../../../common/utils/text';

// Client-side validation mirroring api-reference/admin-semen.md (decisión 0021).
// El padre es nested-or-ref: 'existing' requiere un toro elegido (sire_animal_id);
// 'new' requiere nombre + raza del toro (se crea de referencia, sin número).
const MAX_CODE = 40;
const MAX_NAME = 120;
const MAX_SUPPLIER = 120;
const MAX_SIRE_NAME = 120;
const MAX_SIRE_REGISTER = 60;

export function validateSemen(form) {
    const errors = {};

    const code = cleanName(form.code);
    if (!code) errors.code = 'El código es obligatorio.';
    else if (code.length > MAX_CODE) errors.code = `Máximo ${MAX_CODE} caracteres.`;

    if (form.name && form.name.trim().length > MAX_NAME) errors.name = `Máximo ${MAX_NAME} caracteres.`;
    if (form.supplier && form.supplier.trim().length > MAX_SUPPLIER) errors.supplier = `Máximo ${MAX_SUPPLIER} caracteres.`;

    if (form.sireMode === 'new') {
        const sireName = cleanName(form.newName);
        if (!sireName) errors.newName = 'El nombre del toro es obligatorio.';
        else if (sireName.length > MAX_SIRE_NAME) errors.newName = `Máximo ${MAX_SIRE_NAME} caracteres.`;
        if (!form.newRace) errors.newRace = 'Elegí la raza del toro.';
        if (form.newRegister && form.newRegister.trim().length > MAX_SIRE_REGISTER) errors.newRegister = `Máximo ${MAX_SIRE_REGISTER} caracteres.`;
    } else {
        if (!form.sireAnimal?.id) errors.sire = 'Elegí el toro (padre).';
    }

    return errors;
}
